"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
var _operationsConfig = require("@/api/community/operationsConfig");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'RankSettings',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      form: {
        activeBgList: [],
        // 活跃榜背景图列表
        popularBgList: [],
        // 人气榜背景图列表
        rankRewards: [{
          points: 10
        }, {
          points: 10
        }]
      },
      dialogVisible: false,
      dialogImageUrl: '',
      activeBgPath: '',
      popularBgPath: ''
    };
  },
  mounted: function mounted() {
    this.hydrateFromValue();
    this.loadConfig();
  },
  watch: {
    value: {
      deep: true,
      handler: function handler() {
        this.hydrateFromValue();
      }
    }
  },
  methods: {
    loadConfig: function loadConfig() {
      var _this = this;
      (0, _operationsConfig.getConfigById)(1002).then(function (res) {
        if (res.data && res.data.value) {
          try {
            var config = JSON.parse(res.data.value);
            _this.value = config;
            _this.hydrateFromValue();
          } catch (e) {/* 忽略 */}
        }
      });
    },
    hydrateFromValue: function hydrateFromValue() {
      if (!this.value) return;
      var incoming = this.value || {};
      if (Array.isArray(incoming.rankRewards) && incoming.rankRewards.length) {
        this.form.rankRewards = incoming.rankRewards.map(function (item) {
          return {
            points: Number(item.points) || 0
          };
        });
      }
      // 处理背景图数据 - 用相对路径展示完整URL
      if (incoming.activeBgUrl) {
        this.activeBgPath = incoming.activeBgUrl;
        this.form.activeBgList = [{
          url: (0, _operationsConfig.getImageUrl)('/images/mall' + incoming.activeBgUrl),
          name: 'active-bg.jpg'
        }];
      }
      if (incoming.popularBgUrl) {
        this.popularBgPath = incoming.popularBgUrl;
        this.form.popularBgList = [{
          url: (0, _operationsConfig.getImageUrl)('/images/mall' + incoming.popularBgUrl),
          name: 'popular-bg.jpg'
        }];
      }
    },
    // 超出文件数量限制时的钩子
    onExceed: function onExceed() {
      this.$message.warning('仅可上传一张图片');
    },
    // 图片预览
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 删除活跃榜背景图
    handleActiveBgRemove: function handleActiveBgRemove(file, fileList) {
      this.form.activeBgList = fileList;
      this.activeBgPath = '';
    },
    // 删除人气榜背景图
    handlePopularBgRemove: function handlePopularBgRemove(file, fileList) {
      this.form.popularBgList = fileList;
      this.popularBgPath = '';
    },
    // 活跃榜背景图变化处理 - 立即上传
    handleActiveBgChange: function handleActiveBgChange(file, fileList) {
      var _this2 = this;
      if (file && file.raw) {
        (0, _operationsConfig.uploadImage)(file.raw, '/').then(function (res) {
          _this2.activeBgPath = res.data;
          file.url = (0, _operationsConfig.getImageUrl)('/images/mall' + res.data);
          _this2.form.activeBgList = [file];
        });
      }
    },
    // 人气榜背景图变化处理 - 立即上传
    handlePopularBgChange: function handlePopularBgChange(file, fileList) {
      var _this3 = this;
      if (file && file.raw) {
        (0, _operationsConfig.uploadImage)(file.raw, '/').then(function (res) {
          _this3.popularBgPath = res.data;
          file.url = (0, _operationsConfig.getImageUrl)('/images/mall' + res.data);
          _this3.form.popularBgList = [file];
        });
      }
    },
    beforeUpload: function beforeUpload(file) {
      var isImage = file.type.indexOf('image/') === 0;
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
        return false;
      }
      return true;
    },
    addRank: function addRank() {
      this.form.rankRewards.push({
        points: 10
      });
    },
    removeRank: function removeRank(index) {
      this.form.rankRewards.splice(index, 1);
    },
    onReset: function onReset() {
      this.form.activeBgList = [];
      this.form.popularBgList = [];
      this.form.rankRewards = [{
        points: 10
      }, {
        points: 10
      }];
      this.$emit('input', this.serialize());
      this.$message.success('已重置为默认值');
    },
    onConfirm: function onConfirm() {
      var _this4 = this;
      var payload = {
        activeBgUrl: this.activeBgPath,
        popularBgUrl: this.popularBgPath,
        rankRewards: this.form.rankRewards
      };
      (0, _operationsConfig.updateConfig)(1002, JSON.stringify(payload)).then(function () {
        _this4.$emit('input', payload);
        _this4.$message.success('已保存排行榜设置');
        _this4.loadConfig();
      });
    },
    serialize: function serialize() {
      return {
        activeBgUrl: this.activeBgPath,
        popularBgUrl: this.popularBgPath,
        rankRewards: this.form.rankRewards.map(function (r, idx) {
          return {
            rank: idx + 1,
            points: Number(r.points) || 0
          };
        })
      };
    }
  }
};